"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchListIfNeeded = fetchListIfNeeded;

var _list = require("./../list");

var list = _interopRequireWildcard(_list);

var _SharedActions = require("./../shared/SharedActions");

var SharedActions = _interopRequireWildcard(_SharedActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Akce pro storeSuggest
 */
function fetchListIfNeeded(area, apiCall) {
    return function (dispatch, getState) {
        dispatch(SharedActions.initIfNeeded(area, list.SimpleListReducer));

        dispatch(list.SimpleListActions.fetchIfNeeded(area, null, apiCall));
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYWN0aW9ucy9zdG9yZVN1Z2dlc3RBY3Rpb25zLmpzeCJdLCJuYW1lcyI6WyJmZXRjaExpc3RJZk5lZWRlZCIsImxpc3QiLCJTaGFyZWRBY3Rpb25zIiwiYXJlYSIsImFwaUNhbGwiLCJkaXNwYXRjaCIsImdldFN0YXRlIiwiaW5pdElmTmVlZGVkIiwiU2ltcGxlTGlzdFJlZHVjZXIiLCJTaW1wbGVMaXN0QWN0aW9ucyIsImZldGNoSWZOZWVkZWQiXSwibWFwcGluZ3MiOiI7Ozs7O1FBT2dCQSxpQixHQUFBQSxpQjs7QUFKaEI7O0lBQVlDLEk7O0FBQ1o7O0lBQVlDLGE7Ozs7QUFKWjs7O0FBT08sU0FBU0YsaUJBQVQsQ0FBMkJHLElBQTNCLEVBQWlDQyxPQUFqQyxFQUEwQztBQUM3QyxXQUFPLFVBQUNDLFFBQUQsRUFBV0MsUUFBWCxFQUF3QjtBQUMzQkQsaUJBQVNILGNBQWNLLFlBQWQsQ0FBMkJKLElBQTNCLEVBQWlDRixLQUFLTyxpQkFBdEMsQ0FBVDs7QUFFQUgsaUJBQVNKLEtBQUtRLGlCQUFMLENBQXVCQyxhQUF2QixDQUFxQ1AsSUFBckMsRUFBMkMsSUFBM0MsRUFBaURDLE9BQWpELENBQVQ7QUFDSCxLQUpEO0FBS0giLCJmaWxlIjoic3RvcmVTdWdnZXN0QWN0aW9ucy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQWtjZSBwcm8gc3RvcmVTdWdnZXN0XG4gKi9cbmltcG9ydCAqIGFzIGxpc3QgZnJvbSAnLi8uLi9saXN0J1xuaW1wb3J0ICogYXMgU2hhcmVkQWN0aW9ucyBmcm9tIFwiLi8uLi9zaGFyZWQvU2hhcmVkQWN0aW9uc1wiXG5cblxuZXhwb3J0IGZ1bmN0aW9uIGZldGNoTGlzdElmTmVlZGVkKGFyZWEsIGFwaUNhbGwpIHtcbiAgICByZXR1cm4gKGRpc3BhdGNoLCBnZXRTdGF0ZSkgPT4ge1xuICAgICAgICBkaXNwYXRjaChTaGFyZWRBY3Rpb25zLmluaXRJZk5lZWRlZChhcmVhLCBsaXN0LlNpbXBsZUxpc3RSZWR1Y2VyKSk7XG5cbiAgICAgICAgZGlzcGF0Y2gobGlzdC5TaW1wbGVMaXN0QWN0aW9ucy5mZXRjaElmTmVlZGVkKGFyZWEsIG51bGwsIGFwaUNhbGwpKTtcbiAgICB9XG59XG4iXX0=